import { t } from "@lingui/macro";
import { Button, Dialog, DialogContent, DialogHeader } from "@reactive-resume/ui";

import { TemplateSection } from "@/client/pages/client/builder/sidebars/right/sections/template";
import { useDialog } from "@/client/stores/dialog";

export const DialogTemplate = () => {
  const { isOpen, close } = useDialog("edit-template");

  return (
    <Dialog open={isOpen} onOpenChange={close}>
      <DialogContent className="max-h-[calc(100dvh-2rem)] overflow-hidden rounded-[2rem] border border-indigo-100/70 bg-white p-0 shadow-[0_24px_80px_rgba(71,44,179,0.16)] sm:max-w-5xl">
        <div className="relative overflow-hidden bg-[radial-gradient(120%_120%_at_100%_0%,rgba(71,44,179,0.12)_0%,rgba(255,255,255,0)_42%),radial-gradient(100%_100%_at_0%_100%,rgba(62,207,142,0.08)_0%,rgba(255,255,255,0)_46%)] px-6 pb-5 pt-6 sm:px-8 sm:pt-7">
          <div className="pointer-events-none absolute inset-0 opacity-50 [background-image:radial-gradient(rgba(71,44,179,0.1)_1px,transparent_1px)] [background-size:22px_22px]" />
          <DialogHeader className="relative">
            <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
              <div>
                <div className="mb-2 inline-flex items-center rounded-full bg-[#472cb3]/10 px-3 py-1 text-xs font-bold uppercase tracking-widest text-[#472cb3]">
                  Étape design
                </div>
                <h2 className="text-3xl font-black tracking-tight text-[#22184a]">
                  {t`Templates`}
                </h2>
                <p className="mt-2 max-w-xl text-sm leading-6 text-zinc-500">
                  Choisissez le modèle qui met le mieux en valeur votre parcours. Vous pourrez le
                  personnaliser à tout moment dans l&apos;éditeur.
                </p>
              </div>
              <Button
                variant="primary"
                className="rounded-xl bg-[#472cb3] px-5 text-white shadow-[0_10px_24px_rgba(71,44,179,0.2)] hover:bg-[#392393]"
                onClick={close}
              >
                OK
              </Button>
            </div>
          </DialogHeader>
        </div>
        <TemplateSection />
      </DialogContent>
    </Dialog>
  );
};
